var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('legend', [_vm._v(" Verify Shipment Packing Brand Box")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-9"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scan),
      expression: "scan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "scanVerify",
      "value": "scanVerify"
    },
    domProps: {
      "checked": _vm._q(_vm.scan, "scanVerify")
    },
    on: {
      "change": function($event) {
        _vm.scan = "scanVerify"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "scanVerify"
    }
  }, [_vm._v("Scan Verify ")])]), _vm._v("    \n                   "), _c('span', {
    staticClass: "input-group-text shift-rto"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.scan),
      expression: "scan"
    }],
    attrs: {
      "type": "radio",
      "id": "scanDispute",
      "value": "scanDispute"
    },
    domProps: {
      "checked": _vm._q(_vm.scan, "scanDispute")
    },
    on: {
      "change": function($event) {
        _vm.scan = "scanDispute"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "scanDispute"
    }
  }, [_vm._v(" Scan Dispute ")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-9"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verify),
      expression: "verify"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "VerifyOFD",
      "value": "VerifyOFD"
    },
    domProps: {
      "checked": _vm._q(_vm.verify, "VerifyOFD")
    },
    on: {
      "change": function($event) {
        _vm.verify = "VerifyOFD"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "VerifyOFD"
    }
  }, [_vm._v("Verify OFD ")])]), _vm._v("    \n                  "), _c('span', {
    staticClass: "input-group-text shift-rto"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.verify),
      expression: "verify"
    }],
    attrs: {
      "type": "radio",
      "id": "VerifyNDR",
      "value": "VerifyNDR"
    },
    domProps: {
      "checked": _vm._q(_vm.verify, "VerifyNDR")
    },
    on: {
      "change": function($event) {
        _vm.verify = "VerifyNDR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "VerifyNDR"
    }
  }, [_vm._v(" Verify NDR")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingID),
      expression: "shippingID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('shippingID')
    },
    attrs: {
      "type": "input",
      "name": "shippingID",
      "id": "shippingID",
      "placeholder": "Enter shipmetsID"
    },
    domProps: {
      "value": (_vm.shippingID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.shippingID')),
      expression: "errors.has('form-1.shippingID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter ShipmentID.")])], 1)]), _vm._v(" "), (_vm.scan == 'scanDispute') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.disputeReason),
      expression: "disputeReason"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('disputeReason')
    },
    attrs: {
      "id": "disputeReason",
      "name": "disputeReason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disputeReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select Reason--")]), _vm._v(" "), _vm._l((_vm.disputeReasonList), function(reasonList) {
    return _c('option', {
      domProps: {
        "value": reasonList.Reason
      }
    }, [_vm._v(_vm._s(reasonList.Reason))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.newRTOState')),
      expression: "errors.has('form-1.newRTOState')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Dispute Reason.")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.scan == 'scanDispute') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "textarea",
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    attrs: {
      "rows": "2",
      "name": "comments",
      "id": "comments",
      "placeholder": "Enter comments"
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.comments')),
      expression: "errors.has('form-1.comments')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please enter comments.")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [(_vm.scan == 'scanVerify') ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Verify Brand Box")]) : _vm._e(), _vm._v(" "), (_vm.scan == 'scanDispute') ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Dispute Brand Box")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger",
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Reset")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('legend', [_vm._v(" Selection Panel")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.hubID),
      expression: "hubID"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('disputeReason')
    },
    attrs: {
      "id": "disputeReason",
      "name": "disputeReason",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubID = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select Hub--")]), _vm._v(" "), _vm._l((_vm.hubList), function(hubListing) {
    return _c('option', {
      domProps: {
        "value": hubListing.HubID
      }
    }, [_vm._v(_vm._s(hubListing.HubName))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-9"
  }, [_c('span', {
    staticClass: "input-group-text shift-rto"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifySearch),
      expression: "verifySearch"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "verifyOFDPendeing",
      "value": "VerifyDoneOFDPending"
    },
    domProps: {
      "checked": _vm._q(_vm.verifySearch, "VerifyDoneOFDPending")
    },
    on: {
      "change": function($event) {
        _vm.verifySearch = "VerifyDoneOFDPending"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "verifyOFDPendeing"
    }
  }, [_vm._v("Verify Done OFD Pending ")])]), _vm._v("    \n               "), _c('span', {
    staticClass: "input-group-text shift-rto"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.verifySearch),
      expression: "verifySearch"
    }],
    attrs: {
      "type": "radio",
      "id": "verifyNDRpendeing",
      "value": "OFDDoneNDRPending"
    },
    domProps: {
      "checked": _vm._q(_vm.verifySearch, "OFDDoneNDRPending")
    },
    on: {
      "change": function($event) {
        _vm.verifySearch = "OFDDoneNDRPending"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "verifyNDRpendeing"
    }
  }, [_vm._v(" OFD Done Verify NDR Pending")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": _vm.search
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger",
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Reset")])]), _vm._v(" "), (_vm.searchResult.length != 0) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.searchResult.length != 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.searchResult), function(val) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(val.ShippingId))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.CurrentHubId))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.VerifyReason))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.VerifyType))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.Comments))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.CreatedBy))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.CreatedDate))])])
  }), 0)])])]) : _vm._e()])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Scan Type : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Verify Type : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Shipping ID :")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Dispute Reason : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Comments : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Hub ID  : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Verify Search : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ShippingID")]), _vm._v(" "), _c('th', [_vm._v("Current HubId")]), _vm._v(" "), _c('th', [_vm._v("Process Location")]), _vm._v(" "), _c('th', [_vm._v("Process")]), _vm._v(" "), _c('th', [_vm._v("Comment")]), _vm._v(" "), _c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Created By")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41c1e7db","hasScoped":true}!./src/views/components/VerifyShipmentBrandBox/VerifyShipmentBrandBox.component.html
// module id = 1134
// module chunks = 1